package xyz.luan.bpc.operation

import xyz.luan.bpc.parser.ParsingContext

enum class StepOperation(
    val symbol: String,
    val neutralValue: Double,
) {
    PLUS(symbol = "+", neutralValue = 0.0) {
        override fun process(result: Double, value: Double) = result + value
    },
    MINUS(symbol = "-", neutralValue = 0.0) {
        override fun process(result: Double, value: Double) = result - value
    },
    MULTIPLY(symbol = "*", neutralValue = 1.0) {
        override fun process(result: Double, value: Double) = result * value
    },
    DIVIDE(symbol = "/", neutralValue = 1.0) {
        override fun process(result: Double, value: Double) = result / value
    },

    ;

    abstract fun process(result: Double, value: Double): Double

    companion object {
        fun parse(context: ParsingContext, symbol: String): StepOperation {
            return entries.find { it.symbol == symbol }
                ?: context.fail("Invalid operation symbol: $symbol")
        }
    }
}
